import { Box, Divider, Menu, MenuItem, Paper, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import SearchBar from "../../components/SearchBar";
import Sidebar from "../../components/Sidebar";
import PersonalInfo from "./claims/informations/PersonalInfo";
import ClaimList from "./claims/claim-list/ClaimList";
import History from "./claims/common/History";
import CollapseMenu from "../../components/CollapseMenu";
import { ArticleOutlined } from "../../components/icons";
import PolicyInformation from "../guest-user/claim-creation";
import { toast } from "react-toastify";
import {
  getAllClaims,
  getAllFilteredClaims,
  getClaimBenefit,
  getClaimDetails,
  getClaimHistory,
  searchClaim,
  updateClaim,
  updateTenPercentClaim,
} from "../../services/dashboard";
import { useClaimDetailsStore } from "../../store/useClaimDetailsStore";
import Loader from "../../components/Loader";
import { useAuthStore } from "../../store/useAuthStore";
import { useToast } from "../../hooks/useToast";
import { useClaimTypeStore } from "../../store/useClaimTypeStore";
import { useSessionStore } from "../../store/useSessionStore";
import { useClaimFormStore } from "../../store/useClaimFormStore";
import { useVerifyCheckboxStore } from "../../store/useVerifyCheckboxStore";
import { useTenPercentClaimFormStore } from "../../store/useTenPercentClaimFormStore";
import { useAssignedClaimStore } from "../../store/useAssignedClaimStore";
import dayjs from "dayjs";
import { useUserStore } from "../../store/useUserStore";
import PaymentProceed from "./claims/payment-proceed/PaymentProceed";
import PaymentHistory from "./claims/payment-proceed/PaymentHistory";
import { useOtpVerifiedStore } from "../../store/useOtpVerifiedStore";
import { useLocation, useNavigate } from "react-router-dom";
import MonthlyReports from "./Reports/MonthlyReports";
import ExecutiveReport from "./Reports/Executive";
import { isIfasDriverRole, isIfasRole } from "../../utils/portal";
import { useIfasDashboard } from "./useIfasDashboard";
import {
  CREATE_CLAIM,
  HISTORY,
  IFAS_HOME,
  PAGE_COUNT,
  PERSONAL_INFO,
} from "./constants";

export default function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useAuthStore();
  const setClaimType = useClaimTypeStore((state) => state.setClaimType);
  const { setStatusCounts, setClaims, setFilteredClaims, setSearchedClaim } =
    useClaimDetailsStore();
  const claimType = useClaimTypeStore((state) => state.claimType);
  const setTypeOfClaim = useClaimFormStore((state) => state.setTypeOfClaim);
  const { setIsOtpVerified } = useOtpVerifiedStore();
  const [claimsTotalCount, setClaimsTotalCount] = useState(0);

  const [showCollapse, setShowCollapse] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [claimDetails, setClaimDetails] = useState<any>([]);
  const [historyData, setHistoryData] = useState<any>(null);
  const [historyType, setHistoryType] = useState<"claim" | "case">("claim");
  const [historyBackView, setHistoryBackView] = useState("");
  const [assignmentDetails, setAssignmentDetails] = useState("");
  const [claimStatus, setClaimStatus] = useState("");
  const [page, setPage] = useState(0);
  const [caseSearchText, setCaseSearchText] = useState("");
  const [caseStatusFilter, setCaseStatusFilter] = useState("");
  const [caseList, setCaseList] = useState<any[]>([]);
  const [pageSize] = useState(10);
  const [viewMode, setViewMode] = useState("");
  const [filterAnchorEl, setFilterAnchorEl] = useState<null | HTMLElement>(
    null,
  );
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [isEditable, setIsEditable] = useState(false);
  const [newClaimClick, setNewClaimClick] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(true);
  const [showFilterIcon, setShowFilterIcon] = useState(true);
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [isClaimSearched, setIsClaimSearched] = useState(false);
  const [resassigned, setIsReassigned] = useState();
  const [claimBenefitData, setClaimBenefitData] = useState<any>(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  // Bumped on every sidebar navigation click. Keying the content on this value
  // forces the active portal to remount — and therefore re-fetch — even when the
  // user clicks the item for the view they are already on (viewMode unchanged).
  const [refreshKey, setRefreshKey] = useState(0);


  const handleBenefitTypeChange = (payload: any) => {
    setClaimBenefitData((prev: any) => {
      if (!prev) return prev; // ✅ GUARD

      // Product selection
      if (typeof payload === "string") {
        return {
          ...prev,
          product: {
            ...prev.product,
            selectedType: payload,
          },
        };
      }

      // Supplementary selection
      if (!Array.isArray(prev.supplementaryData)) {
        return prev; // ✅ EXTRA SAFETY
      }

      return {
        ...prev,
        supplementaryData: prev.supplementaryData.map((item: any) =>
          item.supplementary_id === payload.supplementaryId
            ? { ...item, selectedType: payload.type }
            : item,
        ),
      };
    });
  };

  const isFilterMenuOpen = Boolean(filterAnchorEl);

  const { addDocument } = useClaimFormStore.getState();
  const setIsChecked = useVerifyCheckboxStore((state) => state.setIsVerified);
  const { setIsClaimAssigned } = useAssignedClaimStore();
  const role = useUserStore((state) => state.role);
  const { token, userRole, userName, userIdData } = useSessionStore();
  const effectiveRole = userRole || role;
  const isIfasUser = isIfasRole(effectiveRole);
  const isIfasDriver = isIfasDriverRole(effectiveRole);
  const isIfasCaseListView = viewMode === "CASE-PORTAL" && isIfasUser;
  const clearPendingClaimDocuments = () => {
    useClaimFormStore.getState().clearDocuments();
    useTenPercentClaimFormStore.getState().clearTenPercentDocuments();
  };
  const filterStatuses: string[] = isIfasCaseListView
    ? ["DRAFT", "IN_PROGRESS", "COMPLETED", "CANCELLED", "CLAIM_DECLINED"]
    : [
        "DRAFT",
        "VETTED",
        "NEW",
        "REVIEWED",
        "REVIEWED_APPROVED",
        "REVIEWED_DECLINED",
        "APPROVED",
        "DECLINED",
        "PAID",
        "CLOSED",
      ].filter(
        (status) =>
          !(
            claimType === "TEN_PERCENT" &&
            ["REVIEWED", "REVIEWED_APPROVED", "REVIEWED_DECLINED"].includes(status)
          ),
      );

  const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
    // Prevent opening Claims filter menu for IFAS Case Portal; it has its own in-page filters.
    if (viewMode === "CASE-PORTAL" && isIfasUser) return;
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const didMountRef = useRef(false);

  const { showInfoToast } = useToast();

  const statusLabels: Record<string, string> = {
    DRAFT: "Draft",
    VETTED: "Vetted",
    NEW: "New",
    REVIEWED: "Reviewed",
    REVIEWED_APPROVED: "Reviewed - Approved",
    REVIEWED_DECLINED: "Reviewed - Declined",
    APPROVED: "Approved",
    DECLINED: "Declined",
    PAID: "Paid",
    CLOSED: "Closed",
  };


  const handleNewClaimClick = () => {
    setShowCollapse((prev) => !prev);
  };

  const handleHistoryClick = async (id: string) => {
    setIsLoading(true);
    const res = await getClaimHistory(id);
    if (res.status === 200) {
      setHistoryData(res.data);
      setHistoryType("claim");
      setHistoryBackView(PERSONAL_INFO);
      setViewMode(HISTORY);
    } else {
      showInfoToast("Failed to load claim history. Please try again.");
    }
    setIsLoading(false);
  };






  const handleBackFromHistory = () => {
    setViewMode(historyBackView || PERSONAL_INFO);
  };

  const handleDeathClaimSubmit = () => {
    setClaimDetails(null);
    setIsFilterClicked(false);
    setViewMode("");
    if (claimType) {
      callGetAllClaims(page, PAGE_COUNT, claimType);
    }
  };



  const resetData = (type: string) => {
    setViewMode("");
    callGetAllClaims(page, PAGE_COUNT, type);
  };

  const resetToDeathClaimList = async () => {
    setIsEditable(false);
    clearPendingClaimDocuments();
    setClaimType("DEATH");
    setFilteredClaims(null);
    setIsFilterClicked(false);
    setViewMode("");
    resetData("DEATH");
    setShowFilterIcon(!isIfasUser);
    setShowSearchInput(!isIfasUser);
    setSearchedClaim(null);
    setSearchText("");
  };

  const resetToTenPercentClaimList = async () => {
    setIsEditable(false);
    clearPendingClaimDocuments();
    setClaimType("TEN_PERCENT");
    setFilteredClaims(null);
    setIsFilterClicked(false);
    setViewMode("");
    resetData("TEN_PERCENT");
    setShowFilterIcon(!isIfasUser);
    setShowSearchInput(!isIfasUser);
    setSearchedClaim(null);
    setSearchText("");
  };


  const resetToHomeClick = async () => {
    resetListState();

    if (isIfasUser) {
      setViewMode(isIfasDriver ? "BODY-REMOVAL" : IFAS_HOME);
      setShowFilterIcon(!isIfasUser);
      setShowSearchInput(!isIfasUser);
      return;
    }

    setClaimType("DEATH");
    setFilteredClaims(null);
    setIsFilterClicked(false);
    setViewMode("");
    resetData("DEATH");
    setShowFilterIcon(!isIfasUser);
    setShowSearchInput(!isIfasUser);
    setSearchedClaim(null);
    setSearchText("");
  };

  const onPaymentProceedClicked = async () => {
    setIsEditable(false);
    //setClaimType("DEATH");
    setFilteredClaims(null);
    setIsFilterClicked(false);
    setViewMode("CASH-PAYOUT");
    //resetData("DEATH");
    setShowFilterIcon(!isIfasUser);
    setShowSearchInput(!isIfasUser);
    setSearchedClaim(null);
    setSearchText("");
  };

  const onPaymentHistoryClicked = async () => {
    setIsEditable(false);
    //setClaimType("DEATH");
    setFilteredClaims(null);
    setIsFilterClicked(false);
    setViewMode("PAYMENT-HISTORY");
    //resetData("DEATH");
    setShowFilterIcon(!isIfasUser);
    setShowSearchInput(!isIfasUser);
    setSearchedClaim(null);
    setSearchText("");
  };

  // Wraps a sidebar navigation handler so clicking it always remounts the
  // content, even when it targets the view already showing.
  const withRefresh =
    (fn?: () => void) =>
    () => {
      setRefreshKey((k) => k + 1);
      fn?.();
    };


  /**
   * The state every navigation clears before the next destination loads.
   *
   * Was copy-pasted into most of the nav handlers. Collapsed here so the
   * handlers show what is actually different about each destination, and so
   * that C3 has one place to move rather than twenty.
   */
  const resetListState = () => {
    setSearchText("");
    setClaimType("");
    setFilteredClaims(null);
    setIsFilterClicked(false);
    setIsEditable(false);
    setSearchedClaim(null);
  };

  /**
   * The IFAS half of this screen: its state, its navigation and its views.
   *
   * The shell keeps the chrome -- sidebar, header, loader, filter menu -- and
   * everything Claims. It hands the hook the shell state IFAS navigation has to
   * touch on its way past, and gets back handlers it can wire without knowing
   * what they do.
   */
  const ifas = useIfasDashboard({
    effectiveRole,
    isIfasUser,
    isIfasDriver,
    page,
    pageSize,
    setPage,
    searchText,
    setSearchText,
    selectedStatus,
    setSelectedStatus,
    resetListState,
    setViewMode,
    setShowFilterIcon,
    setShowSearchInput,
    setShowCollapse,
    setIsLoading,
    setIsEditable,
    setIsFilterClicked,
    setClaimType,
    setClaimDetails,
    setClaimBenefitData,
    setFilteredClaims,
    setSearchedClaim,
    setHistoryData,
    setHistoryType,
    setHistoryBackView,
    setIsChecked,
    setIsClaimAssigned,
    setIsOtpVerified,
    showInfoToast,
  });

  const onMonthlyReportsClicked = async () => {
    resetListState();
    setViewMode("MONTHLY-REPORT");
    //resetData("DEATH");
    setShowFilterIcon(!isIfasUser);
    setShowSearchInput(!isIfasUser);
  };

  const onExecutiveReportsClick = async () => {
    resetListState();
    setViewMode("EXECUTIVE");
    //resetData("DEATH");
    setShowFilterIcon(!isIfasUser);
    setShowSearchInput(!isIfasUser);
  };


  const handleListItemClick = async (
    id: string,
    reassigned: any,
    role: string,
  ) => {
    setClaimBenefitData(null);
    setIsEditable(false);
    clearPendingClaimDocuments();

    setIsLoading(true);
    setIsClaimAssigned(false);
    setIsReassigned(reassigned);

    const [res, benefitResponse] = await Promise.all([
      getClaimDetails(id, role),
      claimType === "DEATH" ? getClaimBenefit(id) : Promise.resolve(null),
    ]);

    if (benefitResponse?.status === 200) {
      setClaimBenefitData(benefitResponse.data);
    }

    if (res.status === 200) {
      setClaimDetails(res);
      setIsChecked(res.data?.isVerified || false);
      setShowFilterIcon(!isIfasUser);
      setShowSearchInput(!isIfasUser);
      setViewMode(PERSONAL_INFO);
      setAssignmentDetails(res.data.assignedTo);
      useClaimDetailsStore.getState().setAssignmentDetails(res.data.assignedTo);
      setClaimStatus(res.data.claimStatus);
    } else {
      showInfoToast(res.data.message);
    }
    setIsLoading(false);
  };



  const handleMenuItemCLick = (claimType: string) => {
    setIsEditable(false);
    setTypeOfClaim(claimType);
    setClaimType(claimType);
    setViewMode(CREATE_CLAIM);
    setShowCollapse(false);
  };


  const menuItems = [
    {
      label: "10% Claim",
      icon: <ArticleOutlined sx={{ fontSize: "22px" }} />,
      onClick: () => {
        handleMenuItemCLick("TEN_PERCENT");
        setNewClaimClick(true);
      },
    },
    {
      label: "Death Claim",
      icon: <ArticleOutlined sx={{ fontSize: "22px" }} />,
      onClick: () => {
        handleMenuItemCLick("DEATH");
        setNewClaimClick(true);
      },
    },
  ];

  const callGetAllClaims = async (
    page: number,
    pageSize: number,
    type: string,
  ) => {
    if (!type) return;
    setIsLoading(true);
    const res = await getAllClaims(
      userId ? userId : userIdData,
      type,
      page,
      pageSize,
      token,
    );
    if (res?.status === 200) {
      setStatusCounts(res?.data?.statusCounts);
      setClaims(res?.data?.claims);
      if (role === "consultant") {
        setClaimsTotalCount(res?.data?.statusCounts.DRAFT);
      } else if (role === "claim_administrator") {
        setClaimsTotalCount(res?.data?.statusCounts.VETTED);
      } else if (role === "claim_manger") {
        setClaimsTotalCount(res?.data?.statusCounts.NEW);
      } else if (role === "underwriter") {
        setClaimsTotalCount(
          (res?.data?.statusCounts?.REVIEWED ?? 0) +
            (res?.data?.statusCounts?.APPROVED ?? 0) +
            (res?.data?.statusCounts?.DECLINED ?? 0) +
            (res?.data?.statusCounts?.REJECTED ?? 0),
        );
      } else if (role === "finance") {
        setClaimsTotalCount(
          res?.data?.statusCounts.APPROVED + res?.data?.statusCounts.PAID,
        );
      }
    } else {
      showInfoToast(res.data.message);
    }
    setIsLoading(false);
  };

  const handleStatusFilter = async (status: string) => {
    // IFAS Case Portal uses an in-page filter panel (no header filter menu).
    if (viewMode === "CASE-PORTAL" && isIfasUser) {
      ifas.setCaseSelectedStatus(status);
      handleFilterClose();
      setPage(0);
      await ifas.searchIfasCases({ status, searchText, page: 0 });
      return;
    }

    setSelectedStatus(status);
    setSearchedClaim(null);
    handleFilterClose();

    if (!claimType) return;
    setIsLoading(true);
    setPage(0);
    setIsFilterClicked(true);
    callFilterClaims(status, claimType, 0, PAGE_COUNT);
  };

  const getSerachValue = (value: any) => {
    setSearchText(value);
  };

  const handleSearch = async (searchText: string, claimType: any) => {
    if (!searchText.trim()) return;

    const res = await searchClaim(searchText.trim(), claimType);
    if (res?.status === 200) {
      setIsClaimSearched(true);
      setFilteredClaims(null);
      setSelectedStatus(null);
      setSearchedClaim(res?.data.claims);
      setClaimsTotalCount(res?.data?.totalCount);
    } else {
      showInfoToast(res.data.message);
    }
  };

  useEffect(() => {
    if (isIfasUser) return;

    if (claimType) {
      callGetAllClaims(page, PAGE_COUNT, claimType);
    }
    // callGetAllClaims is intentionally kept out to avoid retriggering this fetch on each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimType, isIfasUser, page]);

  useEffect(() => {
    if (!isIfasUser) return;

    setClaimType("");
    setFilteredClaims(null);
    setIsFilterClicked(false);
    setViewMode(isIfasDriver ? "BODY-REMOVAL" : IFAS_HOME);
    setShowFilterIcon(!isIfasUser);
    setShowSearchInput(!isIfasUser);
    setSearchedClaim(null);
    setSearchText("");
  }, [isIfasDriver, isIfasUser, setClaimType, setFilteredClaims, setSearchedClaim]);

  useEffect(() => {
    if (!didMountRef.current) {
      if (isIfasUser) {
        setClaimType("");
        setViewMode(isIfasDriver ? "BODY-REMOVAL" : IFAS_HOME);
        setShowSearchInput(!isIfasUser);
        setShowFilterIcon(!isIfasUser);
        didMountRef.current = true;
        return;
      }
      // Only default to DEATH if no claimType is already set (e.g. coming from another page)
      if (!claimType) setClaimType("DEATH");
      didMountRef.current = true;
    }
  }, [claimType, isIfasDriver, isIfasUser, setClaimType]);

  // If navigation includes a viewMode in location.state, apply it (e.g. from Reports or Notifications)
  useEffect(() => {
    const state: any = (location && (location as any).state) || null;
    if (!state) return;

    if (state.viewMode === "CASH-PAYOUT") {
      onPaymentProceedClicked();
    } else if (state.viewMode === "PAYMENT-HISTORY") {
      onPaymentHistoryClicked();
    } else if (state.viewMode === "CASE_DETAILS" && state.caseNumber) {
      ifas.handleCaseClick({ caseNumber: state.caseNumber });
    } else if (state.viewMode) {
      setViewMode(state.viewMode);
    }

    if (state.claimType) {
      setClaimType(state.claimType);
    }
    // clear navigation state is not necessary here; next navigation will overwrite
    // The handlers are intentionally omitted so location-state redirects run only on navigation changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (!claimDetails?.data?.claimId) return;

    setIsEditable(false);
  }, [claimDetails?.data?.claimId]);

  const handleEditClick = async () => {
    setIsEditable((prev) => !prev);

    if (!isEditable) {
      setIsLoading(true);

      if (claimType === "DEATH") {
        const response = await getClaimBenefit(claimDetails.data.claimId);
        const res = await getClaimDetails(claimDetails.data.claimId, role);

        if (response?.status === 200) {
          const data = response.data;

          const benefitSelections = res.data.benefitSelections || [];

          // 🔹 Create lookup maps
          const productSelectionMap = new Map(
            benefitSelections
              .filter((b: any) => b.product_id)
              .map((b: any) => [b.product_id, b]),
          );

          const supplementarySelectionMap = new Map(
            benefitSelections
              .filter((b: any) => b.supplementary_id)
              .map((b: any) => [b.supplementary_id, b]),
          );

          setClaimBenefitData({
            ...data,

            // ✅ PRODUCT selectedType
            product: {
              ...data.product,
              selectedType: (() => {
                const productSelection = productSelectionMap.get(
                  data.product?.product_id,
                );
                return productSelection
                  ? getSelectedTypeFromSelection(productSelection)
                  : "";
              })(),
            },

            // ✅ SUPPLEMENTARY selectedType
            supplementaryData: Array.isArray(data.supplementaryData)
              ? data.supplementaryData.map((item: any) => {
                const selection = supplementarySelectionMap.get(
                  item.supplementary_id,
                );

                return {
                  ...item,
                  selectedType: selection
                    ? getSelectedTypeFromSelection(selection)
                    : "",
                };
              })
              : [],
          });
        }
      }

      setIsLoading(false);
    }
  };

  const getSelectedTypeFromSelection = (selection: any) => {
    // ✅ Product logic
    if (selection.product_id) {
      if (selection.cash_and_service) return "cash_and_service";
      if (selection.cash_only) return "Cash Only";
      return "Services Only";
    }

    // ✅ Supplementary logic
    if (selection.supplementary_id) {
      if (selection.cash_only) return "Cash";
      return "Service";
    }

    return "";
  };

  const fetchClaimBenefit = async (id: any) => {
    const [res, benefitResponse] = await Promise.all([
      getClaimDetails(id, role),
      getClaimBenefit(id),
    ]);
    if (res?.status === 200) {
      setClaimDetails(res);
      setClaimBenefitData(
        benefitResponse?.status === 200 ? benefitResponse.data : res.data,
      );
    }
  };

  const callFilterClaims = async (
    status: any,
    claimType: string | null,
    page = 0,
    size = 10,
  ) => {
    const res = await getAllFilteredClaims(status, claimType, page, PAGE_COUNT);

    if (res?.status === 200) {
      setFilteredClaims(res?.data.claims);
      setClaimsTotalCount(res?.data?.total_count);
    } else {
      showInfoToast(res.data.message);
    }

    setIsLoading(false);
  };

  const callNextPage = (page: any) => {
    let updatedPage = page - 1;
    setPage(updatedPage);
    if (claimType) {
      if (selectedStatus) {
        callFilterClaims(selectedStatus, claimType, updatedPage, PAGE_COUNT);
      } else {
        callGetAllClaims(updatedPage, PAGE_COUNT, claimType);
      }
    }

    if (viewMode === "CASE-PORTAL" && isIfasUser) {
      void ifas.searchIfasCases({
        status: ifas.caseSelectedStatus,
        searchText,
        page: updatedPage,
      });
    }
  };


  const handleTenPercentFileChange = (key: any, file: File) => {
    useTenPercentClaimFormStore.getState().addTenPercentDocument(key, file);
  };

  const mapBenefitTypeToProduct = (benefitData: any) => {
    const type = benefitData.product.selectedType;

    const isCashAndService = type === "cash_and_service";
    const isCashOnly = type === "Cash Only";
    const isServiceOnly = type === "Services Only";

    return {
      productId: benefitData.product.product_id,
      productName: benefitData.product.plan_and_product_name,

      serviceOnly: isServiceOnly,
      cashOnly: isCashOnly,
      cashAndService: isCashAndService,

      cash: isCashAndService
        ? Number(benefitData?.product?.cash_and_service?.cash ?? 0)
        : !isServiceOnly
          ? Number(benefitData?.product?.cash_only ?? 0)
          : null,

      service: isCashAndService
        ? Number(benefitData?.product?.cash_and_service?.service ?? 0)
        : !isCashOnly
          ? Number(benefitData?.product?.service_only ?? 0)
          : null,
    };
  };

  const handleUpdate = async () => {
    if (!claimDetails?.data?.claimId) {
      showInfoToast("Invalid claim details");
      return;
    }
    setIsLoading(true);

    const tenPercentFiles =
      useTenPercentClaimFormStore.getState().tenPercentdocuments;

    try {
      const formData = new FormData();
      if (claimType === "DEATH") {
        const { documents } = useClaimFormStore.getState();

        const uploadedPolicyDoc = documents["policy_document"];
        const uploadedClaimantDoc = documents["claimant_id_document"];

        if (!claimBenefitData || !claimBenefitData.product) {
          showInfoToast("Benefit data not loaded");
          return;
        }

        const productPayload = mapBenefitTypeToProduct(claimBenefitData);

        const supplementaryPayload = claimBenefitData.supplementaryData.map(
          (item: any) => {
            const type = item.selectedType;

            return {
              supplementaryId: item.supplementary_id,
              supplementaryName: item.supplementary_name,
              productId: productPayload.productId,

              serviceOnly: type === "Service",
              cashOnly: type === "Cash",

              cash: type === "Cash" ? item.cash_only : null,
              service: type === "Service" ? item.service_only : null,
            };
          },
        );

        const docTypeMapping: Record<string, string> = {
          DECEASED_ID: "deceased_id_document",
          POLICE_ACCIDENTAL_REPORT: "police_accidental_report",
          MEDICAL_REPORT: "medical_report",
          DEATH_CERTIFICATE: "death_certificate",
          OTHER_DOCUMENT: "other_document",
          DHA_1663_FORM: "dha_1663_form",
          DHA_1680_HOME_DEATH_FORM: "dha_1680_home_death_form",
          DECEASED_YOUNG_ADULT: "deceased_young_adult",
          BANK_STATEMENT: "bank_statement",
          SIGNATURE_OF_CLAIMANT: "signature_document",
        };

        const claimPayload = {
          typeOfClaim: "DEATH",
          claimId: claimDetails.data.claimId,
          userId: userId,
          policyInfo: {
            policyNumber: claimDetails.data.policyNumber,
            easipolId: "EASI20250526001",
            status: claimDetails.data.claimStatus,
            policyStatus: claimDetails.data.policyResponseDto.policy_status,
            mainMemberName: claimDetails.data.policyResponseDto.member_name,
            policyType: claimDetails.data.policyResponseDto.policy_type,
            policyHolder: "John Doe",
            productHistory: Array.isArray(
              claimDetails.data.policyResponseDto?.product_history,
            )
              ? claimDetails.data.policyResponseDto.product_history.join(", ")
              : claimDetails.data.policyResponseDto?.product_history || "",
            mainMemberContactDetails:
              claimDetails.data.policyResponseDto.member_contact_number,
          },
          bankingInfo: {
            branch: claimDetails.data.bankingInfoResponseDto.branch,
            bankName: claimDetails.data.bankingInfoResponseDto?.bank_name,
            accountType: claimDetails.data.bankingInfoResponseDto.account_type,
            accountTypeId:
              claimDetails.data.bankingInfoResponseDto.account_type ===
                "transmission account"
                ? 3
                : claimDetails.data.bankingInfoResponseDto.account_type ===
                  "savings account"
                  ? 2
                  : claimDetails.data.bankingInfoResponseDto.account_type ===
                    "cheque account"
                    ? 1
                    : claimDetails.data.bankingInfoResponseDto.account_type_id,
            occupation: claimDetails.data.bankingInfoResponseDto.occupation,
            branchCode: claimDetails.data.bankingInfoResponseDto.branch_code,
            countryOfBirth:
              claimDetails.data.bankingInfoResponseDto.country_of_birth,
            isVerified: claimDetails.data.bankingInfoResponseDto.is_verified,
            accountNumber:
              claimDetails.data.bankingInfoResponseDto.account_number,
            cellPhoneNumber:
              claimDetails.data.bankingInfoResponseDto.cell_phone_number,
            emailAddress:
              claimDetails.data.bankingInfoResponseDto.email_address,
            relationship: claimDetails.data.bankingInfoResponseDto.relationship,
            accountName: claimDetails.data.bankingInfoResponseDto.account_name,
            countryOfResidence:
              claimDetails.data.bankingInfoResponseDto.country_of_residence,
            accountHolder:
              claimDetails.data.bankingInfoResponseDto.account_holder,
            submissionDate:
              claimDetails.data.bankingInfoResponseDto.submission_date,
            signatureOfClaimant: "John Doe",
            passportNumber:
              claimDetails.data.bankingInfoResponseDto.passport_number,
            nationality: claimDetails.data.bankingInfoResponseDto.nationality,
            sourceOfFunds:
              claimDetails.data.bankingInfoResponseDto.source_of_funds,
            payableTo: claimDetails.data.bankingInfoResponseDto.payable_to,
          },
          deceased: {
            firstName: claimDetails.data.deceasedResponseDto.first_name,
            lastName: claimDetails.data.deceasedResponseDto.last_name,
            identificationType:
              claimDetails.data.deceasedResponseDto.identification_type,
            identificationNumber:
              claimDetails.data.deceasedResponseDto.identification_number,
            passportNumber:
              claimDetails.data.deceasedResponseDto.passport_number,
            dateOfDeath: claimDetails.data.deceasedResponseDto.date_of_death
              ? dayjs(
                claimDetails.data.deceasedResponseDto.date_of_death,
              ).format("YYYY-MM-DD")
              : null,
            dateOfBirth: claimDetails.data.deceasedResponseDto.date_of_birth
              ? dayjs(
                claimDetails.data.deceasedResponseDto.date_of_birth,
              ).format("YYYY-MM-DD")
              : null,
            relationship: claimDetails.data.deceasedResponseDto.relationship,
            title: claimDetails.data.deceasedResponseDto.title || "N/A",
            initials: claimDetails.data.deceasedResponseDto.initials || "N/A",
            causeOfDeath: claimDetails.data.deceasedResponseDto.cause_of_death,
            isNaturalDeath:
              claimDetails.data.deceasedResponseDto.is_natural_death,
            memberCard: claimDetails.data.deceasedResponseDto.member_card,
          },
          claimant: {
            beneficiaryEmployer:
              claimDetails.data.claimantResponseDto.beneficiary_employer ||
              "N/A",
            claimantCellPhone:
              claimDetails.data.claimantResponseDto.claimant_cell_phone ||
              "N/A",
            lastName: claimDetails.data.claimantResponseDto.last_name || "N/A",
            gender: claimDetails.data.claimantResponseDto.gender || "N/A",
            branchName:
              claimDetails.data.claimantResponseDto.branch_name || "N/A",
            maritalStatus:
              claimDetails.data.claimantResponseDto.marital_status || "N/A",
            employerName:
              claimDetails.data.claimantResponseDto.employee_name || "N/A",
            postalAddress:
              claimDetails.data.claimantResponseDto.postal_address || "N/A",
            contactNumber:
              claimDetails.data.claimantResponseDto.contact_number || "N/A",
            occupation:
              claimDetails.data.claimantResponseDto.occupation || "N/A",
            initials: claimDetails.data.claimantResponseDto.initials || "N/A",
            countryOfBirth:
              claimDetails.data.claimantResponseDto.country_of_birth || "N/A",
            address: claimDetails.data.claimantResponseDto.address || "N/A",
            postalCode:
              claimDetails.data.claimantResponseDto.postal_code || "N/A",
            title: claimDetails.data.claimantResponseDto.title || "N/A",
            countryOfResidence:
              claimDetails.data.claimantResponseDto.country_of_residence ||
              "N/A",
            // dateOfBirth:
            //   claimDetails.data.claimantResponseDto.date_of_birth || "N/A",
            dateOfBirth: claimDetails.data.claimantResponseDto.date_of_birth
              ? dayjs(
                claimDetails.data.claimantResponseDto.date_of_birth,
              ).format("YYYY-MM-DD")
              : "N/A",
            firstName:
              claimDetails.data.claimantResponseDto.first_name || "N/A",
            passportNumber:
              claimDetails.data.claimantResponseDto.passport_number || "N/A",
            nationality:
              claimDetails.data.claimantResponseDto.nationality || "N/A",
            sourceOfFunds:
              claimDetails.data.claimantResponseDto.source_of_funds || "N/A",
            email: claimDetails.data.claimantResponseDto.email || "N/A",
            networkProvider:
              claimDetails.data.claimantResponseDto.network_provider || "N/A",
            agentOrBroker:
              claimDetails.data.claimantResponseDto.agent_or_broker || "N/A",
            relationship:
              claimDetails.data.claimantResponseDto.relationship || "N/A",
            identificationType:
              claimDetails.data.claimantResponseDto.identification_type ||
              "N/A",
            identificationNumber:
              claimDetails.data.claimantResponseDto.identification_number ||
              "N/A",
          },
          product: productPayload,
          supplementary: supplementaryPayload,
          isPolicyUnderWaitingPeriod:
            claimBenefitData.isPolicyUnderWaitingPeriod ?? false,
          isClaimSubmissionWindowExpired:
            claimBenefitData.isClaimSubmissionWindowExpired ?? false,
        };

        const todayLocal = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .split("T")[0];

        if (claimPayload.deceased.dateOfBirth && claimPayload.deceased.dateOfBirth > todayLocal) {
          showInfoToast("Date of birth cannot be in the future");
          setIsLoading(false);
          return;
        }

        if (claimPayload.deceased.dateOfDeath && claimPayload.deceased.dateOfDeath > todayLocal) {
          showInfoToast("Date of death cannot be in the future");
          setIsLoading(false);
          return;
        }

        const jsonBlob = new Blob([JSON.stringify(claimPayload)], {
          type: "application/json",
        });
        formData.append("claim", jsonBlob);

        Object.entries(documents).forEach(([type, file]) => {
          const backendKey = docTypeMapping[type] || type;
          if (file instanceof File) {
            formData.append(backendKey, file);
          }
        });

        if (uploadedPolicyDoc instanceof File) {
          formData.append("policy_document", uploadedPolicyDoc);
        }

        if (uploadedClaimantDoc) {
          formData.append("claimant_id_document", uploadedClaimantDoc);
        }

        const res = await updateClaim(claimDetails.data.claimId, formData);

        if (res?.status === 200) {
          toast.success("Claim updated successfully!");
          setIsEditable(false);
          await fetchClaimBenefit(claimDetails.data.claimId);
        } else {
          showInfoToast(res?.data?.message || "Update failed");
        }
      } else if (claimType === "TEN_PERCENT") {
        const tenPercentPayload = {
          claimId: claimDetails.data.claimId,
          userId: userId || userIdData,
          tenPercentPersonalInfoDto: {
            firstName: claimDetails.data?.claimantResponseDto?.first_name || "",
            lastName: claimDetails.data?.claimantResponseDto?.last_name || "",
            address: claimDetails.data?.claimantResponseDto?.address || "",
            contactNumber:
              claimDetails.data?.claimantResponseDto?.contact_number || "",
            email: claimDetails.data?.claimantResponseDto?.email || "",
            identificationType:
              claimDetails.data?.claimantResponseDto?.identification_type || "",
            identificationNumber:
              claimDetails.data?.claimantResponseDto?.identification_number ||
              "",
            policyNumber:
              claimDetails.data?.claimantResponseDto?.policy_number || "",
          },
          tenPercentBankingInfoDto: {
            bankName:
              claimDetails.data?.bankingInfoResponseDto?.bank_name || "",
            accountName:
              claimDetails.data?.bankingInfoResponseDto?.account_name || "",
            branchCode:
              claimDetails.data?.bankingInfoResponseDto?.branch_code || "",
            accountType:
              claimDetails.data?.bankingInfoResponseDto?.account_type || "",
            accountNumber:
              claimDetails.data?.bankingInfoResponseDto?.account_number || "",
            branchName:
              claimDetails.data?.bankingInfoResponseDto?.branch_name || "",
            is_verified:
              claimDetails.data?.bankingInfoResponseDto?.is_verified || "",
            accountTypeId:
              claimDetails.data?.bankingInfoResponseDto?.account_type ===
                "Transmission Account"
                ? 3
                : claimDetails.data?.bankingInfoResponseDto?.account_type ===
                  "Saving Account"
                  ? 2
                  : claimDetails.data?.bankingInfoResponseDto?.account_type ===
                    "Cheque Account"
                    ? 1
                    : claimDetails.data?.bankingInfoResponseDto
                      ?.account_type_id,
          },
        };

        const tenPercentBlob = new Blob([JSON.stringify(tenPercentPayload)], {
          type: "application/json",
        });
        formData.append("claim", tenPercentBlob);

        // Append 10% specific files
        if (tenPercentFiles?.selfie_with_identity) {
          formData.append(
            "selfie_with_identity",
            tenPercentFiles.selfie_with_identity,
          );
        }
        if (tenPercentFiles?.liveness_check) {
          formData.append("liveness_check", tenPercentFiles.liveness_check);
        }
        if (tenPercentFiles?.home_affairs_verification) {
          formData.append(
            "home_affairs_verification",
            tenPercentFiles.home_affairs_verification,
          );
        }
        if (tenPercentFiles?.bank_proof) {
          formData.append("bank_proof", tenPercentFiles.bank_proof);
        }
        if (tenPercentFiles?.identity_document) {
          formData.append(
            "identity_document",
            tenPercentFiles.identity_document,
          );
        }

        const res = await updateTenPercentClaim(formData);

        if (res?.status === 200) {
          toast.success("Claim updated successfully!");
          useTenPercentClaimFormStore
            .getState()
            .clearTenPercentDocuments();
          const refreshedClaim = await getClaimDetails(
            claimDetails.data.claimId,
            role,
          );
          if (refreshedClaim?.status === 200) {
            setClaimDetails(refreshedClaim);
          }
          setIsEditable(false);
        } else {
          showInfoToast(res?.data?.message || "Update failed");
        }
      }
    } catch (error) {
      showInfoToast("An error occurred while updating the claim");
    } finally {
      setIsLoading(false);
    }
  };

  const renderContent = () => {
    switch (viewMode) {
      case "CREATE_CLAIM":
        return (
          <Box sx={{ flexGrow: 1, overflow: "auto" }}>
            <Box p={3} bgcolor="background.paper">
              <Paper
                elevation={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  minHeight: "calc(100vh - 100px)",
                  borderRadius: 3,
                  background: "#ffffff",
                }}
              >
                <PolicyInformation
                  onSubmit={handleDeathClaimSubmit}
                  compactLayout
                />
              </Paper>
            </Box>
          </Box>
        );

      case "HISTORY":
        return (
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <History
              onBack={handleBackFromHistory}
              historyData={historyData}
              isLoading={isLoading}
              claimDetails={claimDetails}
              historyType={historyType}
            />
          </Box>
        );

      case "CASH-PAYOUT":
        return (
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <PaymentProceed />
          </Box>
        );

      case "PAYMENT-HISTORY":
        return (
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <PaymentHistory />
          </Box>
        );

      case "MONTHLY-REPORT":
        return (
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <MonthlyReports />
          </Box>
        );

      case "EXECUTIVE":
        return (
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <ExecutiveReport />
          </Box>
        );
      case "PERSONAL_INFO":
        return (
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <PersonalInfo
              key={claimDetails?.data?.claimId}
              onHistoryClick={() =>
                handleHistoryClick(claimDetails?.data.claimId)
              }
              resetToClaimList={
                claimType === "DEATH"
                  ? resetToDeathClaimList
                  : resetToTenPercentClaimList
              }
              claimData={claimDetails}
              assignmentDetails={assignmentDetails}
              claimStatus={claimStatus}
              isEditable={isEditable}
              handleUpdate={handleUpdate}
              onEditClick={handleEditClick}
              setClaimDetails={setClaimDetails}
              claimDetails={claimDetails}
              handleFileUpload={(key: string, file: File) => {
                addDocument(key, file);
              }}
              onDocumentFileChange={(key: any, file: any) =>
                handleTenPercentFileChange(key, file)
              }
              isFilterClicked={isFilterClicked}
              isClaimSearched={isClaimSearched}
              reassigned={resassigned}
              claimBenefitData={claimBenefitData}
              onBenefitTypeChange={handleBenefitTypeChange}
            />
          </Box>
        );
      default: {
        const ifasView = ifas.renderView(viewMode);
        if (ifasView) return ifasView;

        return (
          <Box sx={{ flexGrow: 1, overflowY: "auto", height: "100%" }}>
            <ClaimList
              totalClaimCount={claimsTotalCount}
              onSelectClaim={handleListItemClick}
              onStatusCardClick={handleStatusFilter}
              selectedStatus={selectedStatus}
              currentPage={page}
              setCurrentPage={callNextPage}
              rowsPerPage={pageSize}
              claimData={claimDetails}
              resetToClaimList={
                claimType === "DEATH"
                  ? resetToDeathClaimList
                  : resetToTenPercentClaimList
              }
              historyData={historyData}
              setNewClaimClick={setNewClaimClick}
            />
          </Box>
        );
      }
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        // Responsive pass (F.9): the nav is a Drawer below md, so the shell is
        // a column there and only becomes a sidebar+content row once the nav
        // actually docks. `sm` put the drawer trigger in a left gutter column.
        flexDirection: { xs: "column", md: "row" },
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{
          // Below md this subtree renders the ONLY drawer trigger, so it must
          // always mount; `sidebarOpen` is the desktop dock collapse and
          // applies from md up.
          display: {
            xs: "block",
            md: sidebarOpen ? "block" : "none",
          },
          flexShrink: 0,
        }}
      >
        <Sidebar
          /* Responsive pass (F.9): below md the nav is a Drawer and this is the
             ONLY control that opens it — SearchBar's hamburger is the desktop
             dock-collapse and is hidden there. The prop was never passed, so
             Sidebar's trigger had never rendered; without it, narrow viewports
             have no way to reach navigation at all. */
          showHamburger
          onDeathClaimClick={withRefresh(resetToDeathClaimList)}
          onTenPercentClick={withRefresh(resetToTenPercentClaimList)}
          onHomeButtonClick={withRefresh(resetToHomeClick)}
          onPaymentProceedClicked={withRefresh(onPaymentProceedClicked)}
          onPaymentHistoryClicked={withRefresh(onPaymentHistoryClicked)}
          onCasePortalClicked={withRefresh(ifas.onCasePortalClicked)}
          onFuneralPlanningClicked={withRefresh(ifas.onFuneralPlanningClicked)}
          onSpecialServicesClicked={withRefresh(ifas.onSpecialServicesClicked)}
          onCateringPortalClicked={withRefresh(ifas.onCateringPortalClicked)}
          onBodyRemovalClicked={withRefresh(ifas.onBodyRemovalClicked)}
          onMortuaryClicked={withRefresh(ifas.onMortuaryClicked)}
          onWarehouseClicked={withRefresh(ifas.onWarehouseClicked)}
          onBodyDispatchClicked={withRefresh(ifas.onBodyDispatchClicked)}
          onQuotationClicked={withRefresh(ifas.onQuotationClicked)}
          onRevenueClicked={withRefresh(() => setViewMode("REVENUE"))}
          onCatalogueClicked={withRefresh(() => setViewMode("CATALOGUE"))}
          onMemorialsPortalClicked={withRefresh(ifas.onMemorialsPortalClicked)}
          onTombstonePortalClicked={withRefresh(ifas.onTombstonePortalClicked)}
          onFleetClicked={withRefresh(ifas.onFleetClicked)}
          onIfasReportsClicked={withRefresh(ifas.onIfasReportsClicked)}
          onMonthlyReportsClicked={withRefresh(onMonthlyReportsClicked)}
          onExecutiveReportsClick={withRefresh(onExecutiveReportsClick)}
          onDriversClicked={withRefresh(ifas.onDriversClicked)}
          onVehiclesClicked={withRefresh(ifas.onVehiclesClicked)}
          setShowSearchInput={setShowSearchInput}
          setShowFilterIcon={setShowFilterIcon}
        />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          // Flex children default to min-width:auto, which lets a wide child
          // (the Drivers register's 1260px table) push the whole shell wider
          // than the viewport and produce page-level horizontal scroll. The
          // table's own TableContainer keeps the sideways scroll inside the card.
          minWidth: 0,
        }}
      >
        {isLoading ? <Loader isLoading={isLoading} /> : null}
        <Box sx={{ position: "relative", display: "inline-block" }}>
          <SearchBar
            userName={userName}
            userRole={userRole}
            onNewClaimClick={handleNewClaimClick}
            onNewCaseClick={ifas.handleNewCaseCLick}
            onCreateCateringClick={() => { }}
            onNewQuotationClick={ifas.handleNewQuotationClick}
            handleAddDriverClick={ifas.handleAddDriverClick}
            handleAddVehicleClick={ifas.handleAddVehicleClick}
            onFilterMenuClick={handleFilterClick}
            getSerachValue={getSerachValue}
            handleSearch={() => {
              if (viewMode === "CASE-PORTAL" && isIfasUser) {
                setPage(0);
                void ifas.searchIfasCases({
                  status: ifas.caseSelectedStatus,
                  searchText,
                  page: 0,
                });
                return;
              }

              handleSearch(searchText, claimType);
            }}
            searchText={searchText}
            showSearchInput={showSearchInput}
            showFilterIcon={showFilterIcon}
            showHamburger={true}
            onHamburgerClick={() => setSidebarOpen(prev => !prev)}
            newClaimClick={newClaimClick}
            viewMode={viewMode}
          />
          <CollapseMenu
            open={showCollapse}
            position={{ top: 70, right: { xs: 20, sm: 200 } }}
            items={menuItems}
            onClose={() => setShowCollapse(false)}
          />

          <Menu
            anchorEl={filterAnchorEl}
            open={isFilterMenuOpen}
            onClose={handleFilterClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: 3,
                minWidth: 120,
                backgroundColor: "#ffffff",
              },
            }}
          >
            <Typography
              sx={{
                padding: "6px 16px",
                fontWeight: 600,
                color: "white",
                background: "#EC6E00",
              }}
            >
              Filters
            </Typography>
            {/* flatMap, not a Fragment: Menu clones its children to wire up
                keyboard navigation, which a Fragment child would swallow. */}
            {filterStatuses.flatMap((status: string, index: number, array: string[]) => [
                  <MenuItem
                    key={status}
                    onClick={() => handleStatusFilter(status)}
                    selected={
                      viewMode === "CASE-PORTAL"
                        ? ifas.caseSelectedStatus === status
                        : selectedStatus === status
                    }
                    sx={{ py: 0, px: 2 }}
                  >
                    {viewMode === "CASE-PORTAL" && isIfasUser
                      ? status
                      : statusLabels[status] ?? status}
                  </MenuItem>,
                  ...(index < array.length - 1
                    ? [<Divider key={`${status}-divider`} />]
                    : []),
              ])}
          </Menu>
        </Box>
        <React.Fragment key={`${viewMode}-${refreshKey}`}>
          {renderContent()}
        </React.Fragment>
      </Box>
    </Box>
  );
}
